import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
	Card,
	Row,
	Col,
	Form,
	Input,
	Button,
	message,
	Alert,
	Checkbox,
	Switch,
	Divider,
	Typography,
	Collapse,
	Tag,
} from 'antd';
import {
	SaveOutlined,
	CloseCircleOutlined,
	ArrowLeftOutlined,
	EditOutlined,
	PlusCircleOutlined,
	IdcardOutlined,
	TeamOutlined,
	ControlOutlined,
	UnorderedListOutlined,
	DiffOutlined,
	UserOutlined,
	SettingOutlined,
	InfoCircleOutlined,
	CarOutlined,
	CopyOutlined,
	LineChartOutlined,
	SafetyCertificateOutlined,
	LockOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import Config from '../../Config';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	apiUrl: {
		preview: "pegawai/api/jabatan/",
	},
	pageUrl: {
		data: '/admin/jabatan/'
	},
	breadCrumb: [
		<span><TeamOutlined /> Pegawai</span>,
		'Jabatan',
	],
};

const config = new Config();

// Urutan & pengelompokan persis mengikuti urutan menu di AdminSider.jsx,
// supaya admin gampang mencocokkan checklist hak akses dengan menu yang
// benar-benar tampil di sidebar.
const HAK_AKSES_GROUPS = [
	{
		groupKey: 'master',
		title: 'Master',
		icon: <DiffOutlined />,
		children: [
			{ key: 'master_negara', label: 'Negara' },
			{ key: 'master_merek', label: 'Merek' },
			{ key: 'master_jenis_kendaraan', label: 'Jenis Kendaraan' },
			{ key: 'master_Tipe', label: 'Tipe' },
			{ key: 'pengaturan_njkb', label: 'NJKB / Import NJKB' },
			{ key: 'master_layanan', label: 'Layanan' },
			{ key: 'master_warna', label: 'Warna' },
			{ key: 'master_warna_plat', label: 'Warna Plat' },
			{ key: 'master_bahan_bakar', label: 'Bahan Bakar' },
			{ key: 'master_fungsi', label: 'Fungsi' },
			{ key: 'master_payment', label: 'Payment' },
			{ key: 'master_tanda_tangan', label: 'Tanda Tangan SKPD' },
			{ key: 'master_ttd_laporan', label: 'Tanda Tangan Laporan' },
			{ key: 'master_kepemilikan', label: 'Kepemilikan' },
			{ key: 'master_pekerjaan', label: 'Pekerjaan' },
			{ key: 'master_dealer', label: 'Dealer' },
			{ key: 'master_gudang_notice', label: 'Gudang Notice' },
			{ key: 'master_mac_address', label: 'Perangkat / MAC Address' },
			{ key: 'master_kendaraan', label: 'Kendaraan (Pencarian)' },
			{ key: 'master_kendaraan_tambah_manual', label: 'Kendaraan (Tambah Manual)' },
		],
	},
	{
		groupKey: 'pegawai',
		title: 'Pegawai',
		icon: <UserOutlined />,
		children: [
			{ key: 'pegawai_jabatan', label: 'Jabatan' },
			{ key: 'waktu_operasional', label: 'Waktu Operasional' },
			{ key: 'pegawai_upt', label: 'UPT' },
			{ key: 'pegawai_bidang', label: 'Bidang' },
			{ key: 'pegawai_pegawai', label: 'Pegawai' },
		],
	},
	{
		groupKey: 'pengaturan',
		title: 'Pengaturan',
		icon: <SettingOutlined />,
		children: [
			{ key: 'pengaturan_dikon', label: 'Diskon' },
			{ key: 'pengaturan_reward_diskon', label: 'Reward Tepat Waktu' },
			{ key: 'pengaturan_hari_libur', label: 'Hari Libur' },
			{ key: 'pengaturan_umum', label: 'Umum' },
			{ key: 'pengaturan_swdkllj', label: 'SWDKLLJ' },
			{ key: 'pengaturan_adm_stnk', label: 'Adm. STNK' },
			{ key: 'pengaturan_adm_tnkb', label: 'Adm. TNKB' },
			{ key: 'pengaturan_denda_pkb', label: 'Denda PKB' },
			{ key: 'pengaturan_denda_swdkllj', label: 'Denda SWDKLLJ' },
			{ key: 'pengaturan_notice', label: 'Notice' },
{ key: 'pengaturan_printer', label: 'Printer' },
			{ key: 'pengaturan_target_pendapatan', label: 'Target Pendapatan' },
			{ key: 'pengaturan_migrasi_legacy_notice', label: 'Migrasi Legacy Notice' },
			{ key: 'pengaturan_dokumentasi', label: 'Edit Panduan Pengguna' },
		],
	},
	{
		groupKey: 'informasi',
		title: 'Informasi',
		icon: <InfoCircleOutlined />,
		children: [
			{ key: 'informasi_informasi_kendaraan', label: 'Informasi Kendaraan' },
			{ key: 'informasi_cari_kendaraan', label: 'Cari Kendaraan' },
			{ key: 'informasi_migrasi', label: 'Migrasi' },
		],
	},
	{
		groupKey: 'transaksi',
		title: 'Transaksi',
		icon: <CarOutlined />,
		children: [
			{ key: 'blokir', label: 'Blokir' },
			{ key: 'transaksi_pendaftaran_eri', label: 'Pendaftaran dari ERI' },
			{ key: 'transaksi_penetapan_eri', label: 'Penetapan ERI' },
			{ key: 'transaksi_pendaftaran', label: 'Pendaftaran Lama' },
			{ key: 'transaksi_penetapan', label: 'Penetapan' },
			{ key: 'transaksi_pembayaran', label: 'Pembayaran' },
			{ key: 'transaksi_surat_keterangan_fiskal', label: 'Surat Keterangan Fiskal' },
			{ key: 'transaksi_cancle_notice', label: 'Batal Notice' },
			{ key: 'transaksi_histori_notice', label: 'Histori Penggunaan Notice' },
			{ key: 'transaksi_koreksi_nomor_notice', label: 'Koreksi Nomor Notice' },
			{ key: 'transaksi_sinkron_notice', label: 'Sinkronisasi Nomor Notice' },
			{ key: 'transaksi_batal_notice_manual', label: 'Input Batal Notice Manual' },
			{ key: 'transaksi_audit_notice_rusak', label: 'Audit Notice Rusak (Cabut Catatan Rusak)' },
			{ key: 'iwkbu', label: 'IWKBU' },
		],
	},
	{
		groupKey: 'jasa_raharja',
		title: 'Jasa Raharja',
		icon: <SafetyCertificateOutlined />,
		children: [
			{ key: 'jasa_raharja_resend', label: 'Resend Jasa Raharja' },
			{ key: 'master_iwkbu', label: 'Data IWKBU' },
			{ key: 'master_golongan', label: 'Golongan' },
			{ key: 'transaksi_jasa_raharja', label: 'Transaksi JR' },
			{ key: 'transaksi_validasi_setoran', label: 'Validasi Setoran SWDKLLJ' },
			{ key: 'transaksi_smdd', label: 'SMDD' },
			{ key: 'cross_check', label: 'Cross Check SWDKLLJ' },
		],
	},
	{
		groupKey: 'laporan',
		title: 'Laporan',
		icon: <CopyOutlined />,
		children: [
			{ key: 'laporan_pnbp', label: 'PNBP' },
			{ key: 'laporan_kasir', label: 'Kasir' },
			{ key: 'laporan_teller', label: 'Penerimaan Teller' },
			{ key: 'laporan_perekening', label: 'Perekening' },
			{ key: 'laporan_pemutihan', label: 'Pemutihan' },
			{ key: 'laporan_cetak_stnk', label: 'Cetak STNK' },
			{ key: 'laporan_bendahara_penerimaan', label: 'Bendahara Penerimaan' },
			{ key: 'laporan_bendaraha_pkb_bbnkb', label: 'Bendahara PKB & BBNKB' },
			{ key: 'laporan_penetapan_pkb_bbnkb', label: 'Penetapan PKB & BBNKB' },
			{ key: 'laporan_penerimaan_pkb_plat', label: 'Penerimaan PKB Warna Plat' },
			{ key: 'laporan_sum32', label: 'SUM 32' },
			{ key: 'laporan_sts', label: 'STS Harian' },
			{ key: 'laporan_swdkllj', label: 'SWDKLLJ' },
			{ key: 'penyetoran_uang', label: 'Pengantar Penyetoran Uang' },
			{ key: 'laporan_penerimaan_bbnkb_pkb', label: 'Penerimaan BBNKB & PKB' },
			{ key: 'laporan_notice', label: 'Notice' },
			{ key: 'laporan_notice_rusak', label: 'Notice Rusak' },
			{ key: 'laporan_penggunaan_notice_rusak', label: 'Penggunaan Notice & Notice Rusak' },
			{ key: 'laporan_overlap_notice', label: 'Overlap Kode Notice' },
			{ key: 'laporan_duplikat_nopol_aktif', label: 'Duplikat Nopol Aktif' },
			{ key: 'laporan_ba_batal_skpd', label: 'BA Batal SKPD' },
			{ key: 'laporan_status_printer', label: 'Status Printer' },
				{ key: 'laporan_audit_nik', label: 'Audit NIK' },
				{ key: 'approval_koreksi_data_pemilik', label: 'Approval Koreksi Data Pemilik' },
		],
	},
	{
		groupKey: 'analitik',
		title: 'Analitik',
		icon: <LineChartOutlined />,
		children: [
			{ key: 'analitik_proyeksi_potensi_pkb', label: 'Proyeksi Potensi PKB' },
			{ key: 'analitik_tunggakan', label: 'Tunggakan Kendaraan' },
			{ key: 'analitik_list_tunggakan', label: 'List Tunggakan' },
		],
	},
	{
		groupKey: 'secrets',
		title: 'Pengaturan Secrets',
		icon: <LockOutlined />,
		children: [
			{ key: 'secrets_apikey', label: 'API Key' },
			{ key: 'secrets_print_client_config', label: 'Konfigurasi App Cetak' },
		],
	},
];

// Default hak_akses untuk jabatan baru: SEMUA key TIDAK tercentang (false) -
// prinsip least-privilege, jabatan baru mulai tanpa akses apa pun sampai
// admin sengaja mencentang menu yang diperlukan. Konsisten dgn backend
// (_DEFAULT_HAK_AKSES di be/pegawai/serializer.py, semuanya False).
// Saat load jabatan lama, key baru yang belum ada di DB juga ikut default
// false ini (via merge di preview()) - bukan otomatis dapat akses.
function buildDefaultHakAkses() {
	const result = {};
	HAK_AKSES_GROUPS.forEach((group) => {
		result[group.groupKey] = false;
		group.children.forEach((child) => {
			result[child.key] = false;
		});
	});
	return result;
}

const FIELD_STYLE = {
	borderRadius: 8,
	height: 40,
};

class FormJabatan extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,

			aksi: 'tambah',
			method: 'post',
			idLama: '',
			isRedirect: false,

			isMobile: window.innerWidth <= 768,

			dapat_batalkan: false,
			id_edc: false,
			dapat_approve_batal_notice: false,
			dapat_minta_notice: false,
			dapat_kelola_gudang_notice: false,
			dapat_alokasikan_notice: false,
			dapat_migrasi_legacy_notice: false,
			dapat_migrasi_legacy_notice_upt_sendiri: false,
			bebas_peringatan_notice: false,
			bebas_pilih_upt: false,
			dapat_hapus_transaksi_dashboard: false,
			bebas_batas_perangkat: false,
			is_akun_layanan: false,
			hak_akses: buildDefaultHakAkses(),
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		if (this.props.match.params.id != undefined) {
			this.preview(this.props.match.params.id);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					if (!this.formRef.current) return;
					this.formRef.current.setFieldsValue(data);
					for (var key in data) {
						const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
						const dateTimeRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
						if (dateRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY') });
						} else if (dateTimeRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY HH:mm:ss') });
						}
						if (key === 'hak_akses') {
							// Merge (bukan replace) supaya key baru yang ditambahkan ke
							// default hak_akses (mis. master_iwkbu) tetap muncul di checklist
							// untuk jabatan lama yang belum punya key tersebut di data tersimpan.
							this.setState(prev => ({ hak_akses: { ...prev.hak_akses, ...data[key] } }));
						}
						if (key === 'dapat_batalkan_transaksi_upt_lain') {
							this.setState({ dapat_batalkan: data[key] });
						}
						if (key === 'id_edc') {
							this.setState({ id_edc: data[key] });
						}
						if (key === 'dapat_approve_batal_notice') {
							this.setState({ dapat_approve_batal_notice: data[key] });
						}
						if (key === 'dapat_minta_notice') {
							this.setState({ dapat_minta_notice: data[key] });
						}
						if (key === 'dapat_kelola_gudang_notice') {
							this.setState({ dapat_kelola_gudang_notice: data[key] });
						}
						if (key === 'dapat_alokasikan_notice') {
							this.setState({ dapat_alokasikan_notice: data[key] });
						}
						if (key === 'dapat_migrasi_legacy_notice') {
							this.setState({ dapat_migrasi_legacy_notice: data[key] });
						}
						if (key === 'dapat_migrasi_legacy_notice_upt_sendiri') {
							this.setState({ dapat_migrasi_legacy_notice_upt_sendiri: data[key] });
						}
						if (key === 'bebas_peringatan_notice') {
							this.setState({ bebas_peringatan_notice: data[key] });
						}
						if (key === 'bebas_pilih_upt') {
							this.setState({ bebas_pilih_upt: data[key] });
						}
						if (key === 'dapat_hapus_transaksi_dashboard') {
							this.setState({ dapat_hapus_transaksi_dashboard: data[key] });
						}
						if (key === 'bebas_batas_perangkat') {
							this.setState({ bebas_batas_perangkat: data[key] });
						}
						if (key === 'is_akun_layanan') {
							this.setState({ is_akun_layanan: data[key] });
						}
					}
					message.destroy();
					this.setState({ aksi: 'edit', method: 'put', idLama: id + '/' });
				} else {
					const errTitle = 'Gagal memuat data';
					this.setState({ errTitle, errMsg: data });
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => {
		const datas = {
			nama: values.nama,
			hak_akses: this.state.hak_akses,
			dapat_batalkan_transaksi_upt_lain: this.state.dapat_batalkan,
			id_edc: this.state.id_edc,
			dapat_approve_batal_notice: this.state.dapat_approve_batal_notice,
			dapat_minta_notice: this.state.dapat_minta_notice,
			dapat_kelola_gudang_notice: this.state.dapat_kelola_gudang_notice,
			dapat_alokasikan_notice: this.state.dapat_alokasikan_notice,
			dapat_migrasi_legacy_notice: this.state.dapat_migrasi_legacy_notice,
			dapat_migrasi_legacy_notice_upt_sendiri: this.state.dapat_migrasi_legacy_notice_upt_sendiri,
			bebas_peringatan_notice: this.state.bebas_peringatan_notice,
			bebas_pilih_upt: this.state.bebas_pilih_upt,
			dapat_hapus_transaksi_dashboard: this.state.dapat_hapus_transaksi_dashboard,
			bebas_batas_perangkat: this.state.bebas_batas_perangkat,
			is_akun_layanan: this.state.is_akun_layanan,
		};
		this.postData(datas);
	};

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
					this.setState({ isRedirect: true });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleChekbox = (e, name) => {
		const temp = { ...this.state.hak_akses, [name]: e.target.checked };
		this.setState({ hak_akses: temp });
	};

	render() {
		if (this.state.isRedirect) {
			return <Redirect to={configClass.pageUrl.data} />;
		}

		const { isMobile, aksi, errMsg, errTitle, loadingButton, errComponent, dapat_batalkan, id_edc, dapat_approve_batal_notice, dapat_minta_notice, dapat_kelola_gudang_notice, dapat_alokasikan_notice, dapat_migrasi_legacy_notice, dapat_migrasi_legacy_notice_upt_sendiri, bebas_peringatan_notice, bebas_pilih_upt, dapat_hapus_transaksi_dashboard, bebas_batas_perangkat, is_akun_layanan, hak_akses } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Jabatan' : 'Tambah Jabatan';

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-jabatan-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-jabatan-wrap .ant-input,
						.form-jabatan-wrap .ant-select-selector {
							border-radius: 8px !important;
						}
						.form-jabatan-wrap .ant-input:focus,
						.form-jabatan-wrap .ant-select-focused .ant-select-selector {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-jabatan-wrap"
				>
					<Card
						style={{
							borderRadius: 14,
							boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
							overflow: 'hidden',
							maxWidth: 900,
						}}
						bodyStyle={{ padding: 0 }}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex',
							alignItems: 'center',
							gap: 16,
						}}>
							<div style={{
								width: 52,
								height: 52,
								borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								flexShrink: 0,
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									{pageTitle}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit
										? 'Ubah informasi dan hak akses jabatan'
										: 'Isi formulir untuk menambah jabatan baru'
									}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{
										background: 'rgba(255,255,255,0.15)',
										border: 'none',
										color: '#fff',
										borderRadius: 8,
										flexShrink: 0,
									}}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* Section 1: Informasi Jabatan */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							display: 'flex',
							alignItems: 'center',
							gap: 10,
						}}>
							<IdcardOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								Informasi Jabatan
							</Text>
						</div>

						<div style={{ padding: '24px 28px' }}>
							<Form.Item
								label={<span><IdcardOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Jabatan</span>}
								name="nama"
								rules={[{ required: true, message: 'Nama jabatan harus diisi' }]}
							>
								<Input placeholder="Masukkan nama jabatan..." style={FIELD_STYLE} />
							</Form.Item>
						</div>

						{/* Section 2: Konfigurasi Akses */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							borderTop: '1.5px solid #d0dff5',
							display: 'flex',
							alignItems: 'center',
							gap: 10,
						}}>
							<ControlOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								Konfigurasi Akses
							</Text>
						</div>

						<div style={{ padding: '24px 28px' }}>
							<Row gutter={[16, 16]}>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Membatalkan Transaksi UPT Lain"
										extra="Aktifkan untuk jabatan yang berwenang membatalkan pendaftaran kendaraan yang sedang berjalan di UPT lain."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_batalkan}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_batalkan: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Akses EDC"
										extra="Aktifkan jika jabatan ini digunakan oleh mesin EDC — dapat mengakses tagihan lintas UPT tanpa filter."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={id_edc}
											checkedChildren="AKTIF"
											unCheckedChildren="NONAKTIF"
											onChange={(checked) => this.setState({ id_edc: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Menyetujui Batal Notice"
										extra="Aktifkan untuk jabatan yang berwenang menyetujui atau menolak permintaan batal notice dari kasir."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_approve_batal_notice}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_approve_batal_notice: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Mengajukan Permintaan Stok Notice"
										extra="Aktifkan untuk jabatan Kasi TU yang berwenang mengajukan permintaan stok notice dari Gudang Notice untuk UPT-nya."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_minta_notice}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_minta_notice: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Mengelola Gudang Notice"
										extra="Aktifkan untuk jabatan otoritas pusat (Kantor Induk) yang berwenang menambah stok box notice serta menyetujui/menolak permintaan stok dari UPT. Jabatan ini TIDAK bisa menentukan/memindahkan box ke UPT - itu kewenangan Kasi TU."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_kelola_gudang_notice}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_kelola_gudang_notice: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Mengalokasikan Notice ke UPT"
										extra="Aktifkan untuk jabatan Kasi TU yang berwenang menentukan/memindahkan box notice ke UPT/loket mana di kabupatennya, selama box belum aktif dipakai."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_alokasikan_notice}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_alokasikan_notice: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Migrasi Legacy Notice (Semua UPT — Override Pusat)"
										extra="Aktifkan khusus untuk jabatan yang berwenang mendaftarkan box notice dari UPT MANAPUN yang masih pakai counter legacy ke Gudang Notice (migrasi satu kali per UPT, bebas pilih UPT). Sengaja dipisah dari 'Dapat Mengelola Gudang Notice' karena ini operasi sensitif/sekali-jalan, bukan operasional rutin harian. Untuk jabatan yang hanya boleh migrasi UPT sendiri (mis. Kasi Penetapan), pakai switch 'UPT Sendiri' di bawah."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_migrasi_legacy_notice}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_migrasi_legacy_notice: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Migrasi Legacy Notice (UPT Sendiri)"
										extra="Aktifkan untuk jabatan seperti Kasi Penetapan yang sehari-hari sudah mengelola nomor notice UPT sendiri - HANYA bisa migrasi UPT yang sedang mereka pilih setelah login, tidak bisa UPT lain (server mengabaikan pilihan UPT lain walau dipaksa). Lebih aman dari switch 'Semua UPT' di atas karena kesalahan hanya berdampak ke UPT sendiri."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_migrasi_legacy_notice_upt_sendiri}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_migrasi_legacy_notice_upt_sendiri: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Bebas Peringatan Setting Notice"
										extra="Aktifkan untuk jabatan yang tidak bertugas mencetak notice (mis. staf back-office), supaya tidak terus ditampilkan popup peringatan 'Nomor Notice belum disetting' setiap login."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={bebas_peringatan_notice}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ bebas_peringatan_notice: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Bebas Pilih UPT Setelah Login"
										extra="Aktifkan untuk jabatan yang sudah memiliki UPT tetap, supaya tidak diminta memilih UPT lagi setiap kali sesi login berakhir/cookie kedaluwarsa. Pegawai dengan jabatan ini WAJIB sudah punya UPT terisi di data Pegawai - kalau belum, modal tetap akan muncul."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={bebas_pilih_upt}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ bebas_pilih_upt: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Dapat Menghapus Transaksi dari Dashboard"
										extra="Aktifkan untuk jabatan yang berwenang menghapus transaksi berstatus Pendaftaran/Penetapan langsung dari kartu 'Hari Ini' di Dashboard. Transaksi yang sudah Pembayaran tidak bisa dihapus dari sini."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={dapat_hapus_transaksi_dashboard}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ dapat_hapus_transaksi_dashboard: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Bebas Batas Perangkat (Multi-Device)"
										extra="Aktifkan HANYA untuk akun mesin EDC/aplikasi pihak ketiga/integrasi bank yang memang perlu login dari banyak perangkat sekaligus - device_id jadi opsional dan login/koneksi antar perangkat tidak akan saling mengusir. TIDAK direkomendasikan untuk jabatan staf biasa."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={bebas_batas_perangkat}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ bebas_batas_perangkat: checked })}
										/>
									</Form.Item>
								</Col>
								<Col xs={24} sm={24} md={8}>
									<Form.Item
										label="Akun Layanan/Integrasi (Bukan Orang)"
										extra="Aktifkan HANYA untuk akun mesin/integrasi (mis. APP EPAHARI, APP SIGNAL) yang bukan dipakai orang sungguhan - akun dengan jabatan ini TIDAK BISA mengubah password sama sekali, baik punya sendiri (menu Profil) maupun mereset punya pegawai lain."
										style={{ marginBottom: 0 }}
									>
										<Switch
											checked={is_akun_layanan}
											checkedChildren="YA"
											unCheckedChildren="TIDAK"
											onChange={(checked) => this.setState({ is_akun_layanan: checked })}
										/>
									</Form.Item>
								</Col>
							</Row>
						</div>

						{/* Section 3: Hak Akses */}
						<div style={{
							padding: '14px 24px',
							background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
							borderBottom: '1.5px solid #d0dff5',
							borderTop: '1.5px solid #d0dff5',
							display: 'flex',
							alignItems: 'center',
							gap: 10,
						}}>
							<UnorderedListOutlined style={{ color: '#1e4d8a', fontSize: 16 }} />
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								Hak Akses
							</Text>
						</div>

						<div style={{ padding: '20px 28px' }}>
							<Collapse
								defaultActiveKey={HAK_AKSES_GROUPS.map((group) => group.groupKey)}
								expandIconPosition="end"
							>
								{HAK_AKSES_GROUPS.map((group) => {
									const activeCount = group.children.filter((child) => hak_akses[child.key]).length;
									const totalCount = group.children.length;
									return (
										<Collapse.Panel
											key={group.groupKey}
											header={
												<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
													<span style={{ color: '#1e4d8a' }}>{group.icon}</span>
													<span style={{ fontWeight: 600, color: '#0f2847' }}>{group.title}</span>
													<Tag color={activeCount === 0 ? 'default' : activeCount === totalCount ? 'blue' : 'gold'}>
														{activeCount}/{totalCount} aktif
													</Tag>
												</div>
											}
										>
											<Checkbox
												checked={!!hak_akses[group.groupKey]}
												onChange={(e) => this.handleChekbox(e, group.groupKey)}
											>
												<span style={{ fontSize: 13, fontWeight: 600 }}>
													Tampilkan menu {group.title} (induk)
												</span>
											</Checkbox>
											<Divider style={{ margin: '10px 0' }} />
											<Row gutter={[8, 4]}>
												{group.children.map((child) => (
													<Col xs={12} sm={8} md={6} key={child.key}>
														<Form.Item style={{ marginBottom: 8 }}>
															<Checkbox
																checked={!!hak_akses[child.key]}
																onChange={(e) => this.handleChekbox(e, child.key)}
															>
																<span style={{ fontSize: 12 }}>{child.label}</span>
															</Checkbox>
														</Form.Item>
													</Col>
												))}
											</Row>
										</Collapse.Panel>
									);
								})}
							</Collapse>
						</div>

						{/* Footer */}
						<Divider style={{ margin: 0 }} />
						<div style={{
							padding: '16px 28px',
							display: 'flex',
							gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Jabatan'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
	}
)(FormJabatan);
